import * as yup from "yup"
import { Immagine, ImmagineFormType } from "../../types"

export function initialValuesImmagine(immagine?: Immagine | ImmagineFormType | undefined) {
  if (immagine) {
    return immagine
  }
  return {
    titolo: "",
    edizione: undefined,
    tipologia: undefined,
    immagine: "",
    descrizione: "",
    tecnica: undefined,
    incisore: undefined,
    ubicazione: "",
    tags: [],
    mostra_in_cipec: false,
  }
}

export function validationSchemaImmagine(showEdizione: boolean) {
  if (showEdizione) {
    return yup.object().shape({
      titolo: yup.string().required("Campo obbligatorio"),
      edizione: yup.number().required("Campo obbligatorio"),
      tipologia: yup.string().required("Campo obbligatorio"),
      immagine: yup.string().required("Campo obbligatorio"),
    })
  }
  return yup.object().shape({
    titolo: yup.string().required("Campo obbligatorio"),
    tipologia: yup.string().required("Campo obbligatorio"),
    immagine: yup.string().required("Campo obbligatorio"),
  })
}
